import {
  getPropDefaultsBase
} from "./chunk-76FQY6HX.js";
import {
  typographyStyles
} from "./chunk-BU6N4DJ3.js";
import {
  applyTypography
} from "./chunk-XBZNPA3L.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/base/Label.tsx
import styled from "@emotion/styled";
import { jsx } from "@emotion/react/jsx-runtime";
function LabelString(props) {
  const _a = getPropDefaults(props), { children } = _a, rest = __objRest(_a, ["children"]);
  return /* @__PURE__ */ jsx(StyledLabel, __spreadProps(__spreadValues({}, rest), { children }));
}
function getPropDefaults(props) {
  return getPropDefaultsBase(props, { as: props.tag || "span" });
}
var StyledLabel = styled.span`
  ${({ theme, size, colorProp }) => applyTypography(theme, "Label", size, colorProp)}
  ${typographyStyles}
`;

export {
  LabelString,
  getPropDefaults,
  StyledLabel
};
